import { Controller } from "@hotwired/stimulus"

// Live preview of README §2.9. The server (Documents::CalculateTotals) is authoritative.
export default class extends Controller {
  static targets = ["rows", "template", "row", "subtotal", "discount", "tax", "total"]

  connect() {
    this.recalc()
  }

  add() {
    this.rowsTarget.insertAdjacentHTML("beforeend", this.templateTarget.innerHTML.replace(/NEW_RECORD/g, Date.now().toString()))
    this.recalc()
  }

  remove(event) {
    const row = event.target.closest("[data-line-items-target='row']")
    if (row.querySelector("input[name$='[id]']")) {
      row.querySelector("input[name$='[_destroy]']").value = "1"
      row.hidden = true
    } else {
      row.remove()
    }
    this.recalc()
  }

  recalc() {
    let subtotal = 0
    this.rowTargets.filter((row) => !row.hidden).forEach((row) => {
      const amount = round2(num(row, "quantity") * num(row, "unit_price"))
      row.querySelector("[data-field='amount']").textContent = format(amount)
      subtotal = round2(subtotal + amount)
    })
    const percent = this.element.querySelector("[data-field='discount_type']:checked")?.value === "percent"
    const value = num(this.element, "discount_value")
    const discount = Math.min(Math.max(percent ? round2(subtotal * value / 100) : round2(value), 0), subtotal)
    const rate = parseFloat(this.element.querySelector("[data-field='tax_label']")?.selectedOptions[0]?.dataset.rate) || 0
    const tax = round2((subtotal - discount) * rate / 100)

    this.subtotalTarget.textContent = money(subtotal)
    this.discountTarget.textContent = discount > 0 ? `− ${money(discount)}` : money(0)
    this.taxTarget.textContent = money(tax)
    this.totalTarget.textContent = money(round2(subtotal - discount + tax))
  }
}

const num = (scope, field) => parseFloat(scope.querySelector(`[data-field='${field}']`)?.value) || 0
const round2 = (n) => Math.round((n + Number.EPSILON) * 100) / 100
const format = (n) => n.toLocaleString("en-MY", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const money = (n) => `RM ${format(n)}`
